import { ComputeBudgetProgram, Transaction } from "@solana/web3.js";
import i18n from "i18next";

const INVALID_PRIORITY_FEE_LAMPORTS = i18n.t(
  "appPage.errors.invalidPriorityFee"
);

export function addPriorityFeeInstruction(
  transaction: Transaction,
  priorityFeeLamports: number,
  units = 200000
) {
  if (priorityFeeLamports < 0) {
    throw new Error(INVALID_PRIORITY_FEE_LAMPORTS);
  }

  const computeUnitLimitIx = ComputeBudgetProgram.setComputeUnitLimit({
    units,
  });

  const unitPrice = Math.floor((priorityFeeLamports * 10 ** 6) / units);

  const computePriceIx = ComputeBudgetProgram.setComputeUnitPrice({
    microLamports: BigInt(unitPrice),
  });

  const newInstructions = transaction.instructions.filter(
    (ix) =>
      ix.programId.toBase58() !== ComputeBudgetProgram.programId.toBase58()
  );

  newInstructions.unshift(computeUnitLimitIx, computePriceIx);

  return new Transaction().add(...newInstructions);
}
